import React, { useState, useEffect, useRef } from "react";
import { IoArrowBackOutline } from "react-icons/io5";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useGetWorkbookQuery } from "../reduxworkbook/dataApiSlice";
import { useDispatch } from "react-redux";
import { setWorkbookData } from "../reduxworkbook/WorkbookSlice";
import { useMyContext } from "../../MyContext";
import DownloadDataModal from "../DownloadDataModal";
import ViewworkbookHeader2 from "./Components/ViewworkbookHeader2";
import useAuth from "../../hooks/useAuth";
import { conditionForEditWB } from "../smallFunction/conditionForEditWB";
import ViewWBCharts from "./Components/ViewWBCharts";
import RegisterModal from "../auth/RegisterModal";
import PublicPopup from "../auth/PublicPopup";
import ViewworkbookHeader1 from "./Components/ViewworkbookHeader1";
import LoadingIndicator from "../../components/BasicComponents/LoadingIndicator";
import AreYouSureModal from "../reduxworkbook/components/WorkbookComponets/AreYouSureModal";

const GRID_COLUMNS = 24;

export default function PublicViewWorkbook() {
  const { username, roles } = useAuth();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const droppableAreaRef = useRef(null);
  const itemRef = useRef(null);
  const buttonRef = useRef(null);

  const { callFunction } = useMyContext();
  const handleCallFunction = () => {
    callFunction();
  };
  const snapToGrid = (value, gridSize) => {
    console.log(value);
    const convertedPixels = Math.max(0, value * gridSize);
    return convertedPixels;
  };

  const sheetId = searchParams.get("sheetid");
  const workbookId = searchParams.get("workbookid");
  let tutorialModal = false;
  let filterBar = false;
  if (searchParams.get("tutorialmodal")) {
    console.log(searchParams.get("tutorialmodal"));
    if (searchParams.get("tutorialmodal") === "true") {
      tutorialModal = true;
    } else if (searchParams.get("tutorialmodal") === "false") {
      tutorialModal = false;
    }
  }
  if (searchParams.get("filterbar")) {
    console.log(searchParams.get("filterbar"));
    if (searchParams.get("filterbar") === "true") {
      filterBar = true;
    } else if (searchParams.get("filterbar") === "false") {
      filterBar = false;
    }
  }
  console.log(filterBar);
  console.log(tutorialModal);

  const [registerwithGoogleModal, setRegisterwithGoogleModal] = useState(false);
  const [tutorialModalPopup, setTutorialModalPopup] = useState(true);
  const [areYouSureModal, setAreYouSureModal] = useState(true);
  //hi

  const [gridSize, setGridSize] = useState(25);
  const [filterSideBar, setFilterSideBar] = useState(filterBar || false);
  const [currentSheet, setCurrentSheet] = useState(null);

  const [downloadDataModal, setDownloadDataModal] = useState(false);

  const handleDownloadDataModal = () => {
    setDownloadDataModal(true);
    // handleCallFunction()
  };
  if (!localStorage.getItem("referrer")) {
    localStorage.setItem("referrer", document.referrer);
  }
  const {
    data: workbookData,
    isError: isWorkbookError,
    isLoading: isWorkbookLoading,
    isSuccess: isWorkbookSuccess,
    error: workbookError,
  } = useGetWorkbookQuery(workbookId);

  const wbCreatedBy =
    workbookData !== undefined
      ? workbookData.createdBy
        ? workbookData.createdBy
        : "createdBy is not existed"
      : "workbook data is undefined";
  console.log(wbCreatedBy);

  const isEditButtonVisible = conditionForEditWB({
    username,
    roles,
    wbCreatedBy,
  });
  console.log(isEditButtonVisible);
  useEffect(() => {
    if (workbookData !== undefined) {
      dispatch(setWorkbookData(workbookData));
      console.log(workbookData);
    } else {
      console.error("workbook data is undefined");
    }
  }, [workbookId, workbookData]);

  useEffect(() => {
    if (workbookData !== undefined) {
      console.log(workbookData?.parentFolderId);
      if (workbookData?.parentFolderId) {
        sessionStorage.setItem("folderId", workbookData?.parentFolderId);
      }

      if (sheetId) {
        const findSelectedId = workbookData.sheets.find(
          (sheet) => sheet.ID === sheetId
        );
        console.log(findSelectedId);
        if (findSelectedId) {
          if (
            findSelectedId.sheetType === "dashboard" &&
            findSelectedId.SheetsArray.length > 0
          ) {
            setCurrentSheet({
              Sheetid: findSelectedId.ID,
              SheetName: findSelectedId.SheetName,
              SheetType: findSelectedId.sheetType,
              SheetsArray: findSelectedId.SheetsArray,
            });
          } else {
            setCurrentSheet({
              Sheetid: findSelectedId.ID,
              SheetName: findSelectedId.SheetName,
              SheetType: findSelectedId.sheetType,
            });
          }
        }
      } else {
        console.error("sheetId is undefined or null");
      }
    } else {
      console.error("workbook data is undefined");
    }
  }, [sheetId, workbookData]); // Add necessary dependencies

  const handleEditWorkbook = () => {
    console.log(workbookData);
    sessionStorage.setItem("workBookId", workbookData.draftId);
    navigate("/ReduxWorkbook");
  };

  const updateDimensions = () => {
    if (droppableAreaRef.current) {
      const droppableWidth =
        droppableAreaRef.current.getBoundingClientRect().width;
      setGridSize(droppableWidth / GRID_COLUMNS);
    }
  };

  useEffect(() => {
    updateDimensions(); // Initial dimensions
    window.addEventListener("resize", updateDimensions);

    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, [currentSheet, filterSideBar]); // Remove unnecessary dependencies

  //this will only run when currentSheet is null
  useEffect(() => {
    if (workbookData && currentSheet === null) {
      console.log("currentSheet is null");
      const workbookid = workbookData["_id"];
      const sheetid = workbookData["sheets"][0]["ID"];
      navigate(`/publicdashboard?workbookid=${workbookid}&sheetid=${sheetid}`);
    }
    console.log("currentSheet is not null");
  }, [currentSheet]);

  if (isWorkbookLoading) {
    return (
      <div>
        <LoadingIndicator />
      </div>
    );
  }
  if (isWorkbookError) {
    console.log(workbookError);
    return (
      <div className="flex items-center justify-start gap-1 text-red-500 text-xl">
        Error: {workbookError["data"]["message"]}
      </div>
    );
  }

  console.log(currentSheet);

  return isWorkbookSuccess && currentSheet !== null ? (
    <>
      <main className="overscroll-hidden w-full h-screen">
        {/* header 1 hello*/}
        <ViewworkbookHeader1
          workbookData={workbookData}
          workbookId={workbookId}
          isEditButtonVisible={isEditButtonVisible}
          handleEditWorkbook={handleEditWorkbook}
          currentSheet={currentSheet}
          handleDownloadDataModal={handleDownloadDataModal}
          handleCallFunction={handleCallFunction}
          setRegisterwithGoogleModal={setRegisterwithGoogleModal}
          isPublicDashboardTrue={roles.includes("Guest")}
          tutorialModal={tutorialModal}
          openTutorialModal={() => setTutorialModalPopup(true)}
        />
        {/* header 2*/}
        <ViewworkbookHeader2
          workbookData={workbookData}
          workbookId={workbookId}
          sheetId={sheetId}
          isPublicDashboardTrue={roles.includes("Guest")}
        />

        {/* charts of view workbook */}
        <ViewWBCharts
          droppableAreaRef={droppableAreaRef}
          gridSize={gridSize}
          currentSheet={currentSheet}
          itemRef={itemRef}
          snapToGrid={snapToGrid}
          buttonRef={buttonRef}
          setFilterSideBar={setFilterSideBar}
          filterSideBar={filterSideBar}
          sheetId={sheetId}
        />
      </main>
      {/* okaypopup */}

      {tutorialModal
        ? tutorialModalPopup && (
            <PublicPopup
              closeTutorialModal={() => setTutorialModalPopup(false)}
            />
          )
        : null}

      {/* register Modal */}

      {registerwithGoogleModal && (
        <RegisterModal
          closeModal={() => setRegisterwithGoogleModal(false)}
          workbookid={workbookId}
        />
      )}
      {/* Download Data Modal */}
      {workbookData !== undefined && downloadDataModal && (
        <DownloadDataModal
          closeModal={() => setDownloadDataModal(false)}
          workbookData={workbookData}
        />
      )}
      {areYouSureModal ? (
        <AreYouSureModal
          message={"For Better experience switch to desktop mode"}
          closeModal={() => setAreYouSureModal(null)}
          okayButton={() => setAreYouSureModal(null)}
          modalType={"success"}
        />
      ) : null}
    </>
  ) : (
    <button
      className="flex items-center justify-start gap-1 text-red-500 text-xl"
      onClick={() => navigate(-1)}
    >
      <IoArrowBackOutline />
      Sheet Doesn't Exist
    </button>
  );
}
